<template>
  <div class="roleManage">
    <van-cell v-for="(item,i) in list" :key="i" :title="item.name" is-link @click="toAddRole(item)">
    </van-cell>

    <van-button
      type="primary"
      block
      color="#31B158"
      class="add_btn"
      @click="$router.push('/mine/role/addRole')"
    >添加角色</van-button>
  </div>
</template>

<script>
import { role_list, role_set, myShopList } from "@/api/work/mine/role.js";
export default {
  name: "roleManage",
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getList();
     this.$navigation.on("back", (to, from) => {
      if (from.route.name == "mine_role_addRole") {
        this.getList();
      }
    });
  },
  mounted() {},
  methods: {
    getList() {
      role_list().then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    toAddRole(query) {
      this.$router.push({
        path: "/mine/role/addRole",
        query
      });
    }
  }
};
</script>

<style lang="less" scoped>
.roleManage {
  position: relative;
  .add_btn {
    border-radius: 0.16rem;
    width: 6.9rem;
    margin: 0.3rem auto;
  }
}
</style>